export interface FeatureFlagsResponse {
  featureFlags: FeatureFlags;
}

export type FeatureFlags = Record<FeatureFlagsEnum, boolean>;

export enum FeatureFlagsEnum {
  voorbereidingstoets = 'voorbereidingstoets',
  schrijfvaardigheid = 'schrijfvaardigheid',
}
